import React from "react";
import ScoreHorizontal, { ScorePeriodBox, ScorePeriodBoxFight } from 'components/common/ScoreHorizontal'
import { findArray } from 'helpers/utils'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStop,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import Label from "components/general/Label";
import SportCode from "components/common/SportCode";
import Status from "components/presentation/Status";
import { isLiveStatus } from "helpers/status";
import Button from 'react-bootstrap/Button';
import { useEventUnit } from "components/common/EventUnit";

const JudScore = ({ data, category, state, handleClick }) => {

  const eu = useEventUnit()
  const dataHeader = eu(category, false)

  let score;
  if (data?.results) {
    let duration = findArray(data?.results?.extendedInfos, { ei_code: ['DURATION'] })?.ei_value;
    let overtime = findArray(data?.results?.extendedInfos, { ei_code: ['GOLD_SCORE'] });
    let matchDuration;
    let matchOvertime = overtime?.extensions?.find(filter => (filter.eie_code === 'DURATION' && filter.eie_pos === '2'))?.eie_value;;
    if (duration) {
      matchDuration = <><Label data='HeaderContestTime' />: {duration}</>
    }

    if (matchOvertime) {
      matchOvertime = <><Label data='HeaderOvertime' />: {matchOvertime}</>
    }
    let unit = data?.results?.eventUnit?.description;
    let numberGame = findArray(data?.results?.extendedInfos, { ei_code: ['UNIT_NUMBER'] }).ei_value;
    let presentationGame = unit;
    let homeNameSubMatch;
    let homeShortNameSubMatch;
    let awayNameSubMatch;
    let awayShortNameSubMatch;
    let homeColor = 'white';
    let awayColor = 'blue';
    let isTeam = findArray(data?.results?.items, { startSortOrder: [1] })?.participant?.__typename === 'Person' ? false : true;
    let statusMatch = <Status typeToPrint={'result'} scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={data?.results?.status?.code} />;
    let headerRight;
    let noExpandible = true;
    let subMatchGS;

    if (category) {
      noExpandible = false;
      isTeam = false;
      presentationGame = <>{dataHeader} {isLiveStatus(data?.results?.status?.code) && statusMatch}</>;
      let hometeam = findArray(data?.results?.items, { startSortOrder: [1] })?.teamAthletes;
      let awayteam = findArray(data?.results?.items, { startSortOrder: [2] })?.teamAthletes;
      homeNameSubMatch = findArray(hometeam, { order: [1] })?.athlete?.name;
      homeShortNameSubMatch = findArray(hometeam, { order: [1] })?.athlete?.shortName;
      awayNameSubMatch = findArray(awayteam, { order: [1] })?.athlete?.name;
      awayShortNameSubMatch = findArray(awayteam, { order: [1] })?.athlete?.shortName;
      headerRight = <Button variant="outline-secondary" onClick={() => handleClick(!state)} aria-controls={category} aria-expanded={state}><FontAwesomeIcon icon={state ? faMinus : faPlus} /></Button>;
      subMatchGS = findArray(data?.results?.extendedInfos, { ei_code: ['GOLD_SCORE'] })?.ei_value;
    } else {
      if (numberGame) {
        presentationGame = <>{presentationGame}, <Label data='HeaderContest' /> {numberGame} </>;
        headerRight = statusMatch;
      }
    }

    score = <ScoreHorizontal
      data={data}
      homeUniform={isTeam ? homeColor : ''}
      awayUniform={isTeam ? awayColor : ''}

      homeName={homeNameSubMatch}
      homeShortName={homeShortNameSubMatch}
      awayName={awayNameSubMatch}
      awayShortName={awayShortNameSubMatch}

      noExpandible={noExpandible}
      state={state}
      subMatchGS={subMatchGS}

      scoreHeader={{
        left: presentationGame,
        right: headerRight,
      }}
      scoreFooter={
        {
          top: <Periods data={data} isTeam={isTeam} />,
          bottom: <>{matchDuration} {matchOvertime}</>,
        }
      }
    />

  }
  return (
    <>
      {score}
    </>
  )
}

function Periods({ data, isTeam }) {
  let home = findArray(data?.results?.items, { startSortOrder: [1] });
  let homeIPP = home?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'IPP'))?.er_value;
  let homeWAZ = home?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'WAZ'))?.er_value;
  let homeH = home?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'H'))?.er_value;
  let homeX = home?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'X'))?.er_value;
  let homeS3 = home?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'S3'))?.er_value;
  let homeS = parseInt(home?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'S'))?.er_value);
  let homePenalties;

  let away = findArray(data?.results?.items, { startSortOrder: [2] });
  let awayIPP = away?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'IPP'))?.er_value;
  let awayWAZ = away?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'WAZ'))?.er_value;
  let awayH = away?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'H'))?.er_value;
  let awayX = away?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'X'))?.er_value;
  let awayS3 = away?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'S3'))?.er_value;
  let awayS = parseInt(away?.extendedResults?.find(filter => (filter.er_pos === 'TOT' && filter.er_code === 'S'))?.er_value);
  let awayPenalties;

  let goldenScore = findArray(data?.results?.extendedInfos, { ei_code: ['GOLD_SCORE'] }).ei_value;

  if (homeS > 0) {
    for (let i = 0; i < homeS; i++) {
      homePenalties = <>{homePenalties} <FontAwesomeIcon className='icon-yellow' icon={faStop} /></>
    }
  } else if (homeH === '1' || homeX === '1' || homeS3 === '1') {
    homePenalties = <FontAwesomeIcon className='icon-red' icon={faStop} />
  }

  if (awayS > 0) {
    for (let i = 0; i < awayS; i++) {
      awayPenalties = <>{awayPenalties} <FontAwesomeIcon className='icon-yellow' icon={faStop} /></>
    }
  } else if (awayH === '1' || awayX === '1' || awayS3 === '1') {
    awayPenalties = <FontAwesomeIcon className='icon-red' icon={faStop} />
  }

  if (isTeam) {
    return (<></>)
  } else {
    return (
      <>
        <div className="w-100 d-none d-md-flex justify-content-center">
          <ScorePeriodBoxFight
            key={'scorePeriodBlockIppoHome'}
            periodTop={<Label data='HeaderIppon' />}
            periodBottom={homeIPP} />

          <ScorePeriodBoxFight
            key={'scorePeriodBlockWazaariHome'}
            periodTop={<Label data='HeaderWazaari' />}
            periodBottom={homeWAZ} />

          <ScorePeriodBoxFight
            key={'scorePeriodBlockenaltiesHome'}
            periodTop={<Label data='HeaderPenalties' />}
            periodBottom={homePenalties} />

          <div className='score-horizontal-period-name'>
            {goldenScore === 'Y' ? <SportCode discipline='JUD' entity='@Period' code='GS' /> : ''}
          </div>

          <ScorePeriodBoxFight
            key={'scorePeriodBlockIpponAway'}
            periodTop={<Label data='HeaderIppon' />}
            periodBottom={awayIPP} />

          <ScorePeriodBoxFight
            key={'scorePeriodBlockWazaariAway'}
            periodTop={<Label data='HeaderWazaari' />}
            periodBottom={awayWAZ} />

          <ScorePeriodBoxFight
            key={'scorePeriodBlockPenaltiesAway'}
            periodTop={<Label data='HeaderPenalties' />}
            periodBottom={awayPenalties} />
        </div>

        <div className="w-100 d-flex d-md-none justify-content-center">
          <div className="d-flex-block col-4">
            <div className="row w-100 m-0">
              <div className="col-8 text-end score-horizontal-text08 p-0"><Label data='HeaderIppon' /></div>
              <div className="col-4 score-horizontal-text08 text-center p-0">{homeIPP}</div>
            </div>
            <div className="row w-100 m-0">
              <div className="col-8 text-end score-horizontal-text08 p-0"><Label data='HeaderWazaari' /></div>
              <div className="col-4 score-horizontal-text08 text-center p-0">{homeWAZ}</div>
            </div>
            <div className="row w-100 m-0">
              <div className="col-8 text-end score-horizontal-text08 p-0"><Label data='HeaderPenalties' /></div>
              <div className="col-4 score-horizontal-text08 text-center p-0">{homePenalties}</div>
            </div>
          </div>

          <div className="text-center col-4"><strong>{goldenScore === 'Y' ? <SportCode discipline='JUD' entity='@Period' code='GS' /> : ''}</strong></div>

          <div className="d-flex-block col-4">
            <div className="row w-100 m-0">
              <div className="col-4 text-end score-horizontal-text08 text-center p-0">{awayIPP}</div>
              <div className="col-8 text-start score-horizontal-text08 p-0"><Label data='HeaderIppon' /></div>
            </div>
            <div className="row w-100 m-0">
              <div className="col-4 text-end score-horizontal-text08 text-center p-0">{awayWAZ}</div>
              <div className="col-8 text-start score-horizontal-text08 p-0"><Label data='HeaderWazaari' /></div>
            </div>
            <div className="row w-100 m-0">
              <div className="col-4 text-end score-horizontal-text08 text-center p-0">{awayPenalties}</div>
              <div className="col-8 text-start score-horizontal-text08 p-0"><Label data='HeaderPenalties' /></div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default JudScore;